import styled from "@emotion/styled";
import StylesProvider from "@mui/styles/StylesProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { withProfiler } from "@sentry/react";
import itLocale from "date-fns/locale/it";
import DetectUserSession from "../legacy/components/DetectUserSession/detect-user-session";
import { GlobalStickyError } from "../legacy/components/GlobalStickyError";
import { MLDialogProvider } from "../legacy/components/poppers/SnackBarDialog";
import { InitializeApp } from "./initialize-app";
import { ProvideEssentials } from "./provide-app-essentials";
import { AppRouter } from "./router/app-router";

const AppContainer = styled("div")({
  padding: 0,
  margin: 0,
  minWidth: "100%",
  minHeight: "100%",
});

function App() {
  return (
    <InitializeApp>
      <ProvideEssentials>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={itLocale}>
          <StylesProvider injectFirst>
            <MLDialogProvider>
              <GlobalStickyError />
              <AppContainer>
                <AppRouter />
                <DetectUserSession />
              </AppContainer>
            </MLDialogProvider>
          </StylesProvider>
        </LocalizationProvider>
      </ProvideEssentials>
    </InitializeApp>
  );
}

export default withProfiler(App);
